import React from 'react';
import { Loader as TocLoader } from 'timeone-components';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';

const LoaderContainer = styled.div`
  align-items: center;
  background: rgba(254, 254, 254, 0.75);
  display: flex;
  height: 100%;
  justify-content: center;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: all 0.5s;
  left: 0;
  width: 100%;
  z-index: 1;

  &.fade-in-appear-done {
    opacity: 1;
  }

  svg {
    stroke: #007ab3;
  }
`;

function Loader() {
  return (
    <CSSTransition appear in timeout={0} classNames="fade-in">
      <LoaderContainer>
        <TocLoader />
      </LoaderContainer>
    </CSSTransition>
  );
}

export default Loader;
